export default "__VITE_ASSET__10d8866d__"